import { createFileRoute } from '@tanstack/react-router';

import { readWorkOrderName } from '../../features/quality-packs/breadcrumb-data';
import { QualityPackPage } from '../../features/quality-packs/quality-pack-page';

export const Route = createFileRoute('/quality-packs/$workOrderId')({
  staticData: {
    // Resolve the work-order name from the cached checks response so the trail
    // reads "Quality Packs > {work order}" instead of "… > Pack". Returns null
    // until the pack page's checks query has populated the cache.
    breadcrumb: (match, queryClient) => {
      const { workOrderId } = match.params as { workOrderId: string };
      return readWorkOrderName(queryClient, workOrderId);
    },
  },
  component: QualityPackRoute,
});

function QualityPackRoute() {
  const { workOrderId } = Route.useParams();
  return <QualityPackPage workOrderId={workOrderId} />;
}
